import { useQuery } from "@tanstack/react-query";
import { getHotelRatingsForSelect } from "../../api/apiHotelRatings";
import i18next from "i18next";

const useGetHotelRatingsForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["HotelRatingsForSelect", i18next.language],
        queryFn: getHotelRatingsForSelect,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetHotelRatingsForSelect;
